import React, { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import GridLayoutContainer from 'redux/containers/pages/dashboard/GridLayoutContainer'
import { setHomepageArticles } from 'redux/actions'

const Dashboard = ({ homepageArticles }) => {
  const containerRef = useRef('container')
  const contentRef = useRef('content')
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setHomepageArticles(homepageArticles))
  }, [homepageArticles, setHomepageArticles])

  return (
    <div ref={containerRef}>
      <div ref={contentRef}>
        <GridLayoutContainer />
      </div>
    </div>
  )
}

export default Dashboard
